import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { moduli } from '../../config';
import { PregledReversService } from './pregled-revers.service';
import { custom } from 'devextreme/ui/dialog';
import { PdfZaReversService } from 'src/app/pdf-ovi/pdfZaRevers.service';
import DataSource from 'devextreme/data/data_source';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-pregled-revers',
  templateUrl: './pregled-revers.component.html',
  styleUrls: ['./pregled-revers.component.scss']
})

export class PregledReversComponent implements OnInit {
  idkorisnik: any = localStorage.getItem('idsecuser');
  access_token: any = sessionStorage.getItem('token');
  idfirma: any = localStorage.getItem('firma');
  reversi: [] = [];
  stavke: any = [];
  datumOd = moment();
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');
  poruka: string;
  disableGumb: boolean = false;

  statusArray: any = [
    {idstatus: 1, status_vrijednost: 1, status_naziv: 'DA'},
    {idstatus: 2, status_vrijednost: 0, status_naziv: 'NE'}
  ]

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  naslov: string;
  dodaj_urediReversPopupVisible = false;
  prikazi_gumb_uredi = false;
  prikazi_gumb_dodaj = false;
  datum = moment();
  vrijedi_do: any;
  odabranoSkladiste: any;
  odabranoSkladiste_id: any;
  odabraniPartner: any;
  odabraniPartner_id: any;
  odabranoZaglavlje_id: any;
  odabranoZaglavlje_status: any;
  napomena: any;
  napomena2: any;
  skladistaSirovina: any = [];
  partneri: any=[];
  isEdited = true;
  dozvoliUredivanje = false;
  sviArtikli_poslovnica: any = [];
  sviLotovi_poslovnica: any = [];
  artikl_lot: any;
  sviLotovi_artikla: any = [];
  stornirajPopupVisible = false;
  idFirma: any;
  poSifra: any;
  brojDostavnice: any;
  zavrsiPopupVisible = false;
  pzId: any;
  isLoading: boolean = true;
  dozvoli_export: boolean = false;
  zadnjId: any = null;

  constructor(
    private service: PregledReversService,
    private pdfzareversService: PdfZaReversService
  ) {
    this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
    this.dohvatiSkladistaSirovina();
    this.dohvatiPartnere();

    this.onShowing = this.onShowing.bind(this);
    this.odabranArtikl = this.odabranArtikl.bind(this);
    this.odabranLot = this.odabranLot.bind(this);

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().pregledRevers;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {}

  dodajReversPopup() {
    this.naslov = 'Dodaj revers';
    this.dodaj_urediReversPopupVisible = true;
    this.prikazi_gumb_dodaj = true;
    this.prikazi_gumb_uredi = false;
    this.datum = moment();
    this.vrijedi_do = undefined;
    this.odabranoSkladiste = undefined;
    this.odabraniPartner = undefined;
    this.napomena = undefined;
    this.napomena2 = undefined;
  }

  urediReversPopup(e){
    //console.log(e.data);
    this.naslov = 'Uredi revers';
    this.dodaj_urediReversPopupVisible = true;
    this.prikazi_gumb_dodaj = false;
    this.prikazi_gumb_uredi = true;
    this.pzId = e.data.pz_id;
    this.datum = e.data.pz_datum;
    this.vrijedi_do = e.data.pz_vrijedido;
    this.odabranoSkladiste = e.data.poslovnica_po_id;
    this.odabraniPartner = e.data.partner_pa_id;
    this.napomena = e.data.pz_napomena;
    this.napomena2 = e.data.pz_napomena2;
  }

  popupHidden(){
    
  }

  odaberiSkladiste(e){
    //console.log(e);
    if(e.value){
      this.odabranoSkladiste_id = e.value;
      if (e.event) {
        if (this.prikazi_gumb_uredi) {
          this.dohvatiArtikleZaPoslovnicu();
          notify('Promijenili ste skladište. Provjerite stavke!', 'warning', 3000);
        }
      }
    }
  }

  odaberiPartnera(e){
    //console.log(e);
    if(e.value){
      this.odabraniPartner_id = e.value;
    }
  }

  dohvatiSkladistaSirovina() {
    let podaciZaSlanje = {
      idfirma: Number(localStorage.getItem('firma')),
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      //ambalaza_sirovine_potrosni_pekar: 1
    };
    //console.log(podaciZaSlanje);
    this.service.poslovnicaPopis(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.skladistaSirovina = [];
      if (res.success == true) {
        this.skladistaSirovina = res.data;
      }
    });
  }

  dohvatiPartnere(){
    let podaci = {
      access_token: this.access_token,
      idkorisnik: this.idkorisnik,
      idfirma: this.idfirma,
    }
    this.service.dohvatiPartnere(podaci).subscribe(res => {
      if (res.success == true) {
        this.partneri = new DataSource({
          store: res.data
        });
      }
    })
  }

  dodaj_revers(){
    this.dodajRevers().then((addRev: any) =>{
      //console.log('res addRev: ', addRev);
      if (addRev) {
        this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId); 
      }
    });
  }

  dodajRevers(){
    return new Promise((resolve) => {
      this.zadnjId = null;
      let podaciZaSlanje = {
        idkorisnik: Number(localStorage.getItem('idsecuser')),
        idfirma: Number(localStorage.getItem('firma')),
        datum: moment(this.datum).format('YYYY-MM-DD'),
        vrijedi_do: moment(this.vrijedi_do).format('YYYY-MM-DD'),
        idposlovnica: this.odabranoSkladiste_id,
        partner_pa_id: this.odabraniPartner_id,
        napomena: this.napomena,
        napomena2: this.napomena2,
      }
      //console.log(podaciZaSlanje);
      this.service.dodajRevers(podaciZaSlanje).subscribe(res=>{
        //console.log(res);
        if (res.success == true) {
          this.dodaj_urediReversPopupVisible = false;
          notify('Uspješno dodan revers.', 'success', 3000);
          this.zadnjId = res.data[0].zadnjiid;
          resolve(1);
        } else if (res.success == false) {
          notify(res.message, 'error', 3000);
          resolve(0);
        } else {
          notify(res, 'warning', 3000);
          resolve(0);
        }
      });
    });
  }

  uredi_revers(){
    this.urediRevers().then((editRev: any) =>{
      //console.log('res editRev: ', editRev);
      if (editRev) {
        this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId); 
      }
    });
  }

  urediRevers(){
    return new Promise((resolve) => {
      this.zadnjId = null;
      let podaciZaSlanje = {
        idkorisnik: Number(localStorage.getItem('idsecuser')),
        idfirma: Number(localStorage.getItem('firma')),
        pz_id: this.pzId,
        datum: moment(this.datum).format('YYYY-MM-DD'),
        vrijedi_do: moment(this.vrijedi_do).format('YYYY-MM-DD'),
        idposlovnica: this.odabranoSkladiste_id,
        partner_pa_id: this.odabraniPartner_id,
        napomena: this.napomena,
        napomena2: this.napomena2,
      }
      //console.log(podaciZaSlanje);
      this.service.urediRevers(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.dodaj_urediReversPopupVisible = false;
          notify('Uspješno spremljeni podaci.', 'success', 3000);
          resolve(1);
        }else if (res.success == false) {
          notify(res.message, 'error', 3000);
          resolve(0);
        } else{
          notify(res.message, 'error', 3000);
          resolve(0);
        }
      });
    });
  }

  pretrazi(){
    this.zadnjId = null;
    this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
  }

  //dodan i treci parametar kako bi api kod dodavanja novog reversa vratio samo taj zadnje dodani...
  dohvatiReverse(datumod, datumdo, zadnjid): void {
    this.poruka = 'Učitavanje...';
    this.disableGumb = true;
    this.reversi = [];
    this.dozvoli_export = false;
    const data = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      datumod: datumod,
      datumdo: datumdo,
      pz_id: zadnjid
    };
    this.service.dohvatiReverse(data).subscribe((res) => {
      //console.log(res);
      this.disableGumb = false;
      if (res.success === true) {
        this.reversi = res.data;
      }
      if (res.data.length > 0) {
        this.dozvoli_export = true;
        this.poruka = 'Učitavanje...';
      }else{
        this.dozvoli_export = false;
        this.poruka = 'Nema podataka za prikaz!';
      }
    });
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
    //this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran);
  }
  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
    //this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  onSelectionChanged(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);

    this.isLoading = true;

    if (e.currentSelectedRowKeys[0]) {
      e.component.expandRow(e.currentSelectedRowKeys[0]);

      if(e.selectedRowsData[0].pz_status == 'Z' || e.selectedRowsData[0].pz_status == 'S'){
        this.dozvoliUredivanje = false;
      }else{
        this.dozvoliUredivanje = true;
      }

      this.odabranoSkladiste_id = e.selectedRowsData[0].poslovnica_po_id;
      this.odabranoZaglavlje_id = e.selectedRowsData[0].pz_id;
      this.odabranoZaglavlje_status = e.selectedRowsData[0].pz_status;
      if(e.selectedRowsData[0].pz_status == 'I'){
        //zbog kasnjenja u dohvacanju funcije dohvatiArtikleZaPoslovnicu 
        //tj. punjenja sviArtikli_poslovnica i sviLotovi_poslovnica u popup-u za "Uredi stavku" zna biti da nema lotova (this.sviLotovi_artikla)
        //zato je dodan promise tj. "loader", znaci kad dode res pokazuje se popis sa stavkama
        this.dohvatiArtikleZaPoslovnicu().then((artPosl: any) =>{
          //console.log('res artPosl: ', artPosl);
          if (artPosl) {
            this.isLoading = false;
          }
        });
      }else{
        this.isLoading = false;
      }
      
      this.dohvatiStavke();
      
    }
  }

  dohvatiStavke(){
    this.stavke = [];
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      pz_id: this.odabranoZaglavlje_id,
    };
    //console.log(podaciZaSlanje);

    /* kod zavrsenih ili storniranih dohvaca iz jedne tablice a kod onih u izradi iz druge zato su razliciti api-i */
    if (this.odabranoZaglavlje_status == 'Z' || this.odabranoZaglavlje_status == 'S') {
      this.service.dohvatiJednuIzdatnicu(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.stavke = res.data;
        }
      });
    }else{
      this.service.tmpprometstavkePopis(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.stavke = res.data;
        }
      });
    }
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onCellPrepared(e) {
    //console.log(e);
    if (e.rowType == "data") {
      if (e.column.dataField === "pz_status"){
        if (e.value == 'I') {
          e.cellElement.classList.add('circleYellow');
        }
        if (e.value == 'S') {
          e.cellElement.classList.add('circleRed');
        }
        if (e.value == 'Z') {
          e.cellElement.classList.add('circleGreen');
        }
      }
    }
  }

  calculateSortValue(rowData: any) {
    // If your receipt numbers are in format like "PZ-2024-001"
    const receiptNumber = rowData.pz_broj;
    
    // Remove any non-numeric characters and convert to number
    // This will sort based on the numeric value
    return parseInt(receiptNumber.replace(/\D/g, ''));
    
    // OR if you want to sort by the full string but in a specific way:
    // return receiptNumber.padStart(10, '0');
  }

  onRowClick(e) {
    //console.log(e);
    if (e.rowType === 'data' && e.handled !== true) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  onShowing(e: any){
    e.component.option("title", this.naslov);
  }

  onInitNewRow(e: any){
    //console.log(e);
    this.isEdited = true;
    this.naslov = 'Dodaj stavku';
    this.artikl_lot = '';
    this.sviLotovi_artikla = [];
  }

  onEditingStart(e) {
    //console.log(e);
    this.isEdited = false;
    this.naslov = 'Uredi stavku';
    this.artikl_lot = e.data.ar_lot;
    if(e.data.artikl_ar_id){
      this.sviLotovi_artikla = [];
      let vazido = '';
      for (let i = 0; i < this.sviLotovi_poslovnica.length; i++) {
        if (e.data.artikl_ar_id == this.sviLotovi_poslovnica[i].artikl_ar_id) {

          if(this.sviLotovi_poslovnica[i].ar_vazido != null){
            vazido = moment(this.sviLotovi_poslovnica[i].ar_vazido).format('DD.MM.YYYY');
          }else{
            vazido = '';
          }

          this.sviLotovi_artikla.push({
            ar_datum: this.sviLotovi_poslovnica[i].ar_datum,
            ar_lot: this.sviLotovi_poslovnica[i].ar_lot,
            ar_lotstanje: this.sviLotovi_poslovnica[i].ar_lotstanje,
            ar_sifra: this.sviLotovi_poslovnica[i].ar_sifra,
            ar_vazido: this.sviLotovi_poslovnica[i].ar_vazido,
            artikl_ar_id: this.sviLotovi_poslovnica[i].artikl_ar_id,
            firma_fi_id: this.sviLotovi_poslovnica[i].firma_fi_id,
            lb_datizmjene: this.sviLotovi_poslovnica[i].lb_datizmjene,
            lb_id: this.sviLotovi_poslovnica[i].lb_id,
            lot_id_adt: this.sviLotovi_poslovnica[i].lot_id_adt,
            po_sifra: this.sviLotovi_poslovnica[i].po_sifra,
            poslovnica_po_id: this.sviLotovi_poslovnica[i].poslovnica_po_id,
            ar_datum_ar_vazido_ar_lot: moment(this.sviLotovi_poslovnica[i].ar_datum).format('DD.MM.YYYY') + ' - Rok: ' + vazido + ' ' + this.sviLotovi_poslovnica[i].ar_lot
          });
        } 
      }
      //console.log('sviLotovi_artikla: ', this.sviLotovi_artikla);
    }
  }

  dohvatiArtikleZaPoslovnicu(){
    return new Promise((resolve) => {
      let podaciZaSlanje = {
        idkorisnik: Number(localStorage.getItem('idsecuser')),
        idfirma: Number(localStorage.getItem('firma')),
        idposlovnica: this.odabranoSkladiste_id,
        pz_id: this.odabranoZaglavlje_id,
        //izdatnica_trosak: 1
      };
      //console.log(podaciZaSlanje);
      this.sviArtikli_poslovnica = [];
      this.sviLotovi_poslovnica = [];
      this.service.artiklPopisZaPoslovnicu(podaciZaSlanje).subscribe(res=>{
        //console.log('artiklPopisZaPoslovnicu: ', res);
        if (res.success === true) {
          this.sviArtikli_poslovnica = res.data.artikli;
          this.sviLotovi_poslovnica = res.data.lotovi;
          resolve(1);
        }else{
          resolve(0);
        }
      });
    });
  }

  odabranArtikl(e: any){
    //console.log(e);
    //console.log(e.itemData);
    this.artikl_lot = '';
    this.sviLotovi_artikla = [];
    let vazido = '';
    for (let i = 0; i < this.sviLotovi_poslovnica.length; i++) {
      if (e.itemData.ar_id == this.sviLotovi_poslovnica[i].artikl_ar_id) {

        if(this.sviLotovi_poslovnica[i].ar_vazido != null){
          vazido = moment(this.sviLotovi_poslovnica[i].ar_vazido).format('DD.MM.YYYY');
        }else{
          vazido = '';
        }

        this.sviLotovi_artikla.push({
          ar_datum: this.sviLotovi_poslovnica[i].ar_datum,
          ar_lot: this.sviLotovi_poslovnica[i].ar_lot,
          ar_lotstanje: this.sviLotovi_poslovnica[i].ar_lotstanje,
          ar_sifra: this.sviLotovi_poslovnica[i].ar_sifra,
          ar_vazido: this.sviLotovi_poslovnica[i].ar_vazido,
          artikl_ar_id: this.sviLotovi_poslovnica[i].artikl_ar_id,
          firma_fi_id: this.sviLotovi_poslovnica[i].firma_fi_id,
          lb_datizmjene: this.sviLotovi_poslovnica[i].lb_datizmjene,
          lb_id: this.sviLotovi_poslovnica[i].lb_id,
          lot_id_adt: this.sviLotovi_poslovnica[i].lot_id_adt,
          po_sifra: this.sviLotovi_poslovnica[i].po_sifra,
          poslovnica_po_id: this.sviLotovi_poslovnica[i].poslovnica_po_id,
          ar_datum_ar_vazido_ar_lot: moment(this.sviLotovi_poslovnica[i].ar_datum).format('DD.MM.YYYY') + '-' + vazido + ' ' + this.sviLotovi_poslovnica[i].ar_lot
        });
      } 
    }
    //console.log('sviLotovi_artikla: ', this.sviLotovi_artikla); 
  }

  odabranLot(e){
    //console.log(e);
    //console.log(e.itemData);
    this.artikl_lot = e.itemData.ar_lot;
  }

  dodajStavku(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      pz_id: this.odabranoZaglavlje_id,
      idartikl: e.data.artikl_ar_id,
      ps_izlaz: e.data.ps_izlaz,
      ps_izlazc: e.data.ps_izlazc,
      ar_lot: e.data.ar_lot,
    };
    //console.log(podaciZaSlanje);
    this.service.tmpprometstavkeDodaj(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.sviLotovi_artikla = [];
      this.dohvatiStavke();
      if (res.success === true) {
        notify('Uspješno dodana stavka.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  urediStavku(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      idtmpprometstavke: e.data.ps_id,
      pz_id: e.data.prometzag_pz_id,
      idartikl: e.data.artikl_ar_id,
      ps_izlaz: e.data.ps_izlaz,
      ps_izlazc: e.data.ps_izlazc,
      /* bilo */
      //ar_lot: e.data.ar_lot,
      ar_lot: this.artikl_lot,
    };
    //console.log(podaciZaSlanje);
    this.service.tmpprometstavkeUredi(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      this.dohvatiStavke();
      if (res.success === true) {
        notify('Uspješno spremljeni podaci.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  zavrsiPopup(e){
    //console.log(e);
    this.pzId = e.data.pz_id
    this.zavrsiPopupVisible = true;
  }

  zavrsiRevers() {
    this.zadnjId = null;
    var lot = this.stavke.map(e => e.ar_lot).indexOf(null);
    //console.log(lot);
    // if (lot > -1) {
    //   notify('Postoje stavke koje nemaju LOT!', 'error', 3000);
    // }else{
      let podaciZaSlanje = {
        idkorisnik: Number(localStorage.getItem('idsecuser')),
        idfirma: Number(localStorage.getItem('firma')),
        pz_id: this.pzId
      };
      //console.log(podaciZaSlanje);
      this.service.zavrsiRevers(podaciZaSlanje).subscribe((res) => {
        //console.log(res);
        if (res.success === true) {
          this.zavrsiPopupVisible = false;
          this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
          notify('Uspješno završen revers.', 'success', 3000);
        }else{
          notify(res.message, 'error', 3000);
        }
      });
    //}
  }

  obrisiRevers(e: any){
    this.zadnjId = null;
    //console.log(e.data);
    let myDialog = custom({
      title: "Brisanje",
      messageHtml: "Jeste li sigurni da želite obrisati revers?",
      buttons: [{
        text: "DA",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      },{
        text: "NE",
        onClick: (e) => {
          //console.log(e);
          return { buttonText: e.component.option("text") }
        }
      }]
    });
    myDialog.show().then((dialogResult: any) => {
      //console.log(dialogResult.buttonText);
      if(dialogResult.buttonText === 'DA'){
        this.service.obrisiRevers({
          idkorisnik: Number(localStorage.getItem('idsecuser')),
          idfirma: Number(localStorage.getItem('firma')),
          pz_id: e.data.pz_id
        }).subscribe(res=>{
          //console.log(res)
          if(res.success == true){
            this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
            notify('Uspješno ste obrisali revers.', 'success');
          } else {
            notify('Došlo je do pogreške. Pokušajte ponovno.', 'error');
          }
        });
      }else{  }
    });
  }

  obrisiStavku(e) {
    //console.log(e);
    let podaciZaSlanje = {
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      idfirma: Number(localStorage.getItem('firma')),
      idtmpprometstavke: e.data.ps_id,
      pz_id: e.data.prometzag_pz_id
    };
    //console.log(podaciZaSlanje);
    this.service.tmpprometstavkeObrisi(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        notify('Uspješno obrisana stavka.', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  reversPDF(data) {
    //console.log(data);
    this.pdfzareversService.reversPDF(data);
  }

  stornirajPopup(e) {
    //console.log(e.data);
    this.idFirma = e.data.firma_fi_id;
    this.poSifra = e.data.po_sifra;
    this.brojDostavnice = e.data.pz_broj;
    this.pzId = e.data.pz_id;
    this.stornirajPopupVisible = true;
  }

  storniraj() {
    this.zadnjId = null;
    let podaciZaSlanje = {
      idfirma: this.idFirma,
      idkorisnik: Number(localStorage.getItem('idsecuser')),
      po_sifra: this.poSifra,
      pz_broj: this.brojDostavnice,
      pz_id: this.pzId,
    };
    //console.log(podaciZaSlanje);
    this.service.stornirajRevers(podaciZaSlanje).subscribe((res) => {
      //console.log(res);
      if (res.success == true) {
        this.stornirajPopupVisible = false;
        this.dohvatiReverse(this.datumOdFormatiran, this.datumDoFormatiran, this.zadnjId);
        notify('Uspješno ste stornirali revers...', 'success', 3000);
      } else {
        notify(res.message, 'error', 3000);
      }
    });
  }
}